import { Box, IconButton, Typography } from '@mui/material';

import React, {  } from 'react';
import { Close } from '@mui/icons-material'
import __t from "../../../lib/traduzioni";
import useBSSLogger from '../../../hooks/useBSSLogger';
import BSSDrawer from '../../form/BSSDrawer';


const {logger} = useBSSLogger();

const NotePrezzo = ({mostraNotePreventivo, setMostraNotePreventivo}) => {
    return (
        <>
            <BSSDrawer
                open={mostraNotePreventivo.mostra} 
                onClose={e => setMostraNotePreventivo({preventivoSelezionato: null, mostra: false})}
            >
                <Box p={3}>
                    <Box>   
                        <Typography variant="h3">    
                            <IconButton color="primary" onClick={e => setMostraNotePreventivo({preventivoSelezionato: null, mostra: false})}>
                                <Close />
                            </IconButton>
                            {mostraNotePreventivo?.preventivoSelezionato?.description ?? ""}
                        </Typography>
                    
                        
                    </Box>
                        
                        

                    <Box py={2}>
                        {mostraNotePreventivo?.preventivoSelezionato?.note ?? __t("nessunanota")}                        
                    </Box>
                    
                </Box>
                
            </BSSDrawer>
        </>
    )
}

export default NotePrezzo;